import { createSelector } from 'reselect';

const selectScribeConversation = state => state.scribeConversation;

export const selectAllMicsSelected = createSelector(
  [selectScribeConversation],
  scribeConversation => scribeConversation.allMicsSelected
);

export const selectStatus = createSelector([selectScribeConversation], scribeConversation => scribeConversation.status);

export const selectInTwilioCalls = createSelector(
  [selectScribeConversation],
  scribeConversation => scribeConversation.inTwilioCalls
);

export const selectSpeakers = createSelector(
  [selectScribeConversation],
  scribeConversation => scribeConversation.speakers
);

export const selectTranscripts = createSelector(
  [selectScribeConversation],
  scribeConversation => scribeConversation.transcripts
);

export const selectEditedWords = createSelector(
  [selectScribeConversation],
  scribeConversation => scribeConversation.editedWords
);

export const selectLang = createSelector([selectScribeConversation], scribeConversation => scribeConversation.lang);
